import React from 'react';
import { withContent } from '../../hoc/withContext';
import {
  PriceBannerBlockContainer,
  PriceBannerDescription, PriceBannerImageContainer, PriceBannerInformationContainer,
  PriceMonthText, PriceBannerSubscriptionButton, SubscriptionPriceText, PrinceTextContainer,
  UbisoftPlusLogoContainer, SubscriptionPriceContainer
} from './PriceBannerBlockStyle';
import { IContent } from '../../types';
import { ReactComponent as UbisoftPlusLogo } from '../../assets/ubisoft_plus_logo.svg';
import { currencyFormatter } from '@mooncake/utils/sfcc/currency';
import PictureImage from '../UI/Image/Picture';
import SubscriptionButton from '../SubscriptionButton/SubscriptionButton';
import '../Hero/Hero.scss';
import SubscriptionPrice from '../UI/Price/SubscriptionPrice';

const IMAGE_NAME = 'valhala_fenyx_rysing_background';

interface IPriceBannerProps {
  context?: IContent;
}

const PriceBannerBlock = ({ context }: IPriceBannerProps) => {
  return (
    <PriceBannerBlockContainer>
      <PriceBannerImageContainer>
        <PictureImage
          images={[{
            imageName: IMAGE_NAME + '_desktop',
            minWidth: 850
          }, {
            imageName: IMAGE_NAME + '_mobile',
            minWidth: 0
          }
          ]}
          extension="jpg"
          altText={IMAGE_NAME}
          className={['']}
        />
      </PriceBannerImageContainer>
      <PriceBannerInformationContainer>
        <UbisoftPlusLogoContainer>
          <UbisoftPlusLogo />
        </UbisoftPlusLogoContainer>
        <PriceBannerDescription>{context.priceBanner.subTitle}</PriceBannerDescription>
        <SubscriptionPriceContainer> <SubscriptionPrice /> </SubscriptionPriceContainer>
        <PriceBannerSubscriptionButton>
          <SubscriptionButton context={''} idToAttach={'priceBannerSubscriptionButton'} />
        </PriceBannerSubscriptionButton>
      </PriceBannerInformationContainer>
    </PriceBannerBlockContainer>
  );
};

export default withContent(PriceBannerBlock);